export default __webpack_public_path__ + "static/media/wezijnerKlein.33d1c84c.jpg";